import React, { useState } from "react";
import { employeeData } from "../data/employeeData";
import { RxCross1, RxCross2 } from "react-icons/rx";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import toast from "react-hot-toast";

const Employee = () => {
  const [data, setData] = useState(employeeData);
  const [menuOpen, setMenuOpen] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [location, setLocation] = useState("");
  const [email, setEmail] = useState("");
  const [editId, setEditId] = useState(null);
  const [submitted, setSumbitted] = useState(false);

  const handleSubmit = () => {
    setSumbitted(true);
    if (!name || !phone || !location || !email) {
      toast.error("Fill all the fields");
      return;
    }
    if (editId) {
      const updateItem = data.map((item) =>
        item.id === editId ? { ...item, name, phone, location, email } : item
      );
      toast.success("Employee Edit Successfully");
      console.log(updateItem);

      setData(updateItem);
    } else {
      const newData = { id: data.length + 1, name, phone, location, email };
      toast.success("Employee Add Successfully");
      console.log(newData);

      setData([...data, newData]);
    }

    setName("");
    setPhone("");
    setEmail("");
    setLocation("");
    setEditId("");
    setMenuOpen(false);
    setSumbitted(false);
  };

  const handleEdit = (data) => {
    setEditId(data.id);
    setName(data.name);
    setPhone(data.phone);
    setLocation(data.location);
    setEmail(data.email);
    setMenuOpen(true);
  };

  const handleDelete = (id) => {
    const deleteItem = data.filter((item) => item.id !== id);
    toast.success("employe deleted Successfully");
    console.log(deleteItem);

    setData(deleteItem);
  };

  return (
    <div className=" mt-[10%] md:mt-[4%] px-5">
      <div className=" flex justify-end">
        <button
          className=" rounded-md px-4 py-2 bg-primary text-third text-sm"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          Add
        </button>
      </div>
      <div className="">
        <table className=" w-full mt-5">
          <thead>
            <tr>
              {["S.No", "Name", "Phone", "Location", "Email", "Action"].map(
                (col, i) => (
                  <th
                    key={i}
                    className=" border-b  font-bold px-4 py-4 text-left text-primary"
                  >
                    {col}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {data.map((emp, i) => (
              <tr key={i} className=" hover:bg-third  cursor-pointer">
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {i + 1}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {emp.name}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {emp.phone}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {emp.location}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  {emp.email}
                </td>
                <td className=" border-b text-sm font-medium px-4 py-4 text-left">
                  <button>
                    <CiEdit fontSize={25} onClick={() => handleEdit(emp)} />
                  </button>
                  <button>
                    <MdDeleteOutline
                      fontSize={25}
                      onClick={() => handleDelete(emp.id)}
                    />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {menuOpen && (
          <div className=" flex justify-end items-center bg-black bg-opacity-20 inset-0 fixed z-20 ">
            <div className=" bg-white p-6  w-96 rounded-md h-screen ">
              <div className=" flex justify-between mt-5">
                <h4 className=" font-bold text-primary text-xl">
                  Employee Detail
                </h4>
                <button
                  className=" hover:text-primary "
                  onClick={() => setMenuOpen(false)}
                >
                  <RxCross2 fontSize={20} />
                </button>
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Name:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {submitted && (
                  <p className=" text-xs font-medium text-red-500">
                    Name is required
                  </p>
                )}
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Phone:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter phone "
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                {submitted && (
                  <p className=" text-xs font-medium text-red-500">
                    Phone is required
                  </p>
                )}
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Location :</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter location"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                />
                {submitted && (
                  <p className=" text-xs font-medium text-red-500">
                    Location is required
                  </p>
                )}
              </div>
              <div className=" mt-3">
                <label className=" mb-1 font-bold text-lg">Email:</label>
                <input
                  className=" px-4 py-2 rounded-md border border-gray-300 hover:border-primary text-sm w-full outline-none"
                  type="text"
                  placeholder="Enter email "
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {submitted && (
                  <p className=" text-xs font-medium text-red-500">
                    Email is required
                  </p>
                )}
              </div>

              <div className=" mt-5">
                <button
                  className=" bg-primary w-full px-4 py-2 rounded-md text-white text-sm font-semibold"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Employee;
